import type {BioIconProps} from './common-types'

export function ShieldRankingIcon({...attributes}: BioIconProps) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M9.5 12.7498L11.75 14.9998L15.5 9.74985M12.5 2.71411C10.3495 4.75073 7.44563 5.99986 4.25 5.99986C4.19922 5.99986 4.14852 5.99955 4.09789 5.99892C3.7099 7.17903 3.5 8.43995 3.5 9.74991C3.5 15.3414 7.32432 20.0397 12.5 21.3719C17.6757 20.0397 21.5 15.3414 21.5 9.74991C21.5 8.43995 21.2901 7.17903 20.9021 5.99892C20.8515 5.99955 20.8008 5.99986 20.75 5.99986C17.5544 5.99986 14.6505 4.75073 12.5 2.71411Z"
        stroke="#030303"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
